<template>
    <div>
        <div v-for="(child, index) in petition" :key="index">
            <div class="main-list-wrap">
                <div class="vx-row m-0 main-list-panel">
            <div class="vx-col md:w-1/3 w-full p-0"
                v-if="checkProperty(child,'name') || checkProperty(child,'firstName') ||
                    checkProperty(child,'middleName') || checkProperty(child,'lastName')">
                <div class="main-list">
                    <p>
                        Full Name
                        <span>{{ formatFullname(child) }}</span>
                    </p>
                </div>
            </div>
            <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(child, 'locationOfBirth')">
                <div class="main-list">
                    <p>
                        First Name
                        <span>{{ checkProperty(child, 'locationOfBirth') }}</span>
                    </p>
                </div>
            </div>
            <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(child, 'locationOfBirth')">
                <div class="main-list">
                    <p>
                        Middle Name
                        <span>{{ checkProperty(child, 'locationOfBirth') }}</span>
                    </p>
                </div>
            </div>
            <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(child, 'locationOfBirth')">
                <div class="main-list">
                    <p>
                        Last Name
                        <span>{{ checkProperty(child, 'locationOfBirth') }}</span>
                    </p>
                </div>
            </div>
            <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(child, 'maidenName')">
                <div class="main-list">
                    <p>
                        Maiden Name
                        <span>{{ checkProperty(child, 'maidenName') }}</span>
                    </p>
                </div> 
            </div>
            <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(child,'dateOfBirth')">
                <div class="main-list">
                    <p>
                        Date of Birth
                        <span>{{ checkProperty(child, 'dateOfBirth') | formatDate }}</span>
                    </p>
                </div>
            </div>
            <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(child, 'countryOfBirthDetails') && checkProperty(child, 'countryOfBirthDetails','name')">
                <div class="main-list">
                    <p>
                        Country of Birth
                        <span>{{ checkProperty(child, 'countryOfBirthDetails','name') }}</span>
                    </p>
                </div> 
            </div>
            <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(child, 'provinceOfBirthDetails') && checkProperty(child, 'provinceOfBirthDetails','name')">
                <div class="main-list">
                    <p>
                        Province of Birth
                        <span>{{ checkProperty(child, 'provinceOfBirthDetails','name') }}</span>
                    </p>
                </div>
            </div>
            <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(child, 'locationOfBirth')">
                <div class="main-list">
                    <p>
                        Location of Birth
                        <span>{{ checkProperty(child, 'locationOfBirth') }}</span>
                    </p>
                </div>
            </div>
            
            
              
            <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(child, 'countryOfBirthDetails') && checkProperty(child, 'relationshipToYou')">
                <div class="main-list">
                    <p>
                        Relationship to you
                        <span>{{ checkProperty(child, 'relationshipToYou') }}</span>
                    </p>
                </div> 
            </div>
        </div>
            </div>
        </div>
    </div>
</template>
    
<script>
import documentsView from "@/views/common/documentsView.vue";
import _ from "lodash";
export default {
    components: {
      
        documentsView,
    },
    data: () => ({
        visastatuses: [],
        docPrivew: false,
    }),
    props: {
        petition: {
      type: Object,
      default: null
    },

    },
    computed: {

    },
    methods: {
        formatFullname(item) {
            let returnVal = ''
            if (this.checkProperty(item, 'name')) {
                return returnVal = this.checkProperty(item, 'name')
            }
            else {
                if (this.checkProperty(item, 'firstName')) {
                    returnVal = this.checkProperty(item, 'firstName')
                }
                if (this.checkProperty(item, 'middleName')) {
                    returnVal = returnVal + ' ' + this.checkProperty(item, 'middleName')
                }
                if (this.checkProperty(item, 'lastName')) {
                    returnVal = returnVal + ' ' + this.checkProperty(item, 'lastName')
                }
                return returnVal
            }
        },downloadfile(value) {
            this.$emit('download_or_view' ,value);
         },
        download_or_view(value) {
            if (_.has(value, "path")) {
                value['url'] = value['path'];
                value['document'] = value['path'];
            }

            if (_.has(value, "url")) {
                value['path'] = value['url'];
                value['document'] = value['url'];
            }

            if (_.has(value, "document")) {
                value['path'] = value['document'];
                value['url'] = value['document'];
            }

            this.selectedFile = value;
            this.docValue = '';
            this.docPrivew = false;
            this.docType = false;
            this.docType = this.findmsDoctype(value);

            if (this.docType == "office" || this.docType == "image") {

                value.url = value.url.replace(this.$globalgonfig._S3URL, "");
                value.url = value.url.replace(this.$globalgonfig._S3URLAWS, "");
                let postdata = {
                    keyName: value.url
                };
                this.$store.dispatch("getSignedUrl", postdata).then((response) => {
                    this.docValue = response.data.result.data;

                    if (this.docType == "office") {
                        this.docValue = encodeURIComponent(response.data.result.data);
                    }
                    this.docPrivew = true;
                });

            } else {
                this.downloads3file(value);
            }

        },

    },
    mounted() {

    }
};
</script>
    